/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ApiDefPaymentRecoveryResponse } from '../../models/api-def-payment-recovery-response';

export interface OrganizationsGetPaymentRecovery$Params {

/**
 * The ID of the organization
 */
  organizationId: string;

/**
 * Exact pending subscription mutation whose hosted recovery action is requested.
 */
  mutationId: string;
}

export function organizationsGetPaymentRecovery(http: HttpClient, rootUrl: string, params: OrganizationsGetPaymentRecovery$Params, context?: HttpContext): Observable<StrictHttpResponse<ApiDefPaymentRecoveryResponse>> {
  const rb = new RequestBuilder(rootUrl, organizationsGetPaymentRecovery.PATH, 'get');
  if (params) {
    rb.path('organizationId', params.organizationId, {});
    rb.query('mutationId', params.mutationId, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<ApiDefPaymentRecoveryResponse>;
    })
  );
}

organizationsGetPaymentRecovery.PATH = '/organizations/{organizationId}/subscription/payment-recovery';
